import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { InlineInputGroup, Radio } from 'barnyard/components';
import RuleForm from '../inputs/RuleForm';
import InlineRegionSelect from '../inputs/InlineRegionSelect';
import InlineInputNumber from '../inputs/InlineInputNumber';


class IncorrectVendorRule extends Component {
  constructor(props) {
    super(props);
    _.bindAll(this, 'onPercentSubmit', 'onDollarSubmit', 'onReset');
    const { initialValues } = props;
    this.initialState = {
      isDollar: true,
      total: initialValues.total || 10000,
      percent: initialValues.percent || 50,
      regions: initialValues.regions && initialValues.regions.length > 0 ? initialValues.regions : [0]
    };
    this.state = this.initialState;
  }


  onPercentSubmit(event) {
    event.preventDefault();
    this.props.onSubmit({
      kind: 'more_expensive_vendor_frequency',
      regions: _.filter(this.state.regions),
      value: {
        percent: this.state.percent
      }
    });
  }

  onDollarSubmit(event) {
    event.preventDefault();
    this.props.onSubmit({
      kind: 'more_expensive_vendor',
      regions: _.filter(this.state.regions),
      value: {
        total: this.state.total
      }
    });
  }

  onReset() {
    this.setState(this.initialState);
  }

  render() {
    const {
      total, percent, regions, isDollar,
    } = this.state;
    const { form, type, ...other } = this.props;

    return (
      <RuleForm
        {...other}
        onSubmit={isDollar ? this.onDollarSubmit : this.onPercentSubmit}
        onReset={this.onReset}
        isSubmitting={form.is_submitting}
      >
        <InlineRegionSelect
          onChange={val => this.setState({ regions: val })}
          value={regions}
        />
        <InlineInputGroup
          label='Type'
          description='Type of limit'
          InputComponent={Radio.Group}
          value={isDollar}
          onChange={e => this.setState({ isDollar: e.target.value })}
        >
          <Radio value={true}>Chooses a vendor that results in a net loss of...</Radio>
          <Radio value={false}>Fails to choose the lowest cost vendor as a percentage...</Radio>
        </InlineInputGroup>
        {isDollar ? (
          <InlineInputNumber
            label='Monthly Net Loss'
            description='Size of net loss from selecting more expensive products'
            displayFormat='dollar'
            value={total}
            onChange={value => this.setState({ total: value })}
          />
        ) : (
          <InlineInputNumber
            label='More Expensive Percentage'
            description='Percent of time a more expensive vendor is selected'
            displayFormat='percent'
            value={percent}
            onChange={value => this.setState({ percent: value })}
          />
        )}
      </RuleForm>
    );
  }
}

IncorrectVendorRule.defaultProps = {
  type: 'add',
  initialValues: {}
};

IncorrectVendorRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default IncorrectVendorRule;
